/* global window */
( function( window, $, undefined ) {
	"use strict";
	var document = window.document,

	CATALOG = {
		common: {

			// Application-wide code.
			init: function() {

				// Restores email addresses misted by the no_spam helper
				$( ".atk14_no_spam" ).unobfuscate( {
					atstring: "[at-sign]",
					dotstring: "[dot-sign]"
				} );

				// Form hints.
				$( ".help-hint" ).each( function() {
					var $this = $( this ),
						$field = $this.closest( ".form-group" ).find( ".form-control" ),
						title = $this.data( "title" ) || "",
						content = $this.html(),
						popoverOptions = {
							html: true,
							trigger: "focus",
							title: title,
							content: content
						};

					$field.popover( popoverOptions );
				} );

				// Menu open/collapse
				$( ".navbar-toggler" ).on( "click", function() {
					if ( $( ".navbar-collapse" ).hasClass( "show" ) ) {
						$( "nav.navbar" ).removeClass( "is-open" );
					} else {
						$( "nav.navbar" ).addClass( "is-open" );
					}
				} );

				// Menu - animate scroll + hide on click
				$( "nav.navbar .navbar-collapse a" ).on( "click", function( e ) {
					if ( $( ".navbar-collapse" ).hasClass( "show" ) ) {
						$( ".navbar-toggler" ).trigger( "click" );
					}

					// Pokud je link lokalni anchor, animujeme prechod
					if ( $( this ).attr( "href" ).substr( 0, 1 ) === "#" ) {
						if (  $( this ).attr( "href" ).length > 1 ) {
							var pos = $( $( this ).attr( "href" ) ).offset().top;
							if ( !isNaN( pos ) ) {
								$( "html, body" ).animate( { scrollTop: pos }, 400 );
								e.preventDefault();
							}
						}
					}
				} );
			}
		},

		logins: {
			create_new: function() {
				$( "#id_login" ).focus();
			}
		},

		users: {

			// Controller-wide code.
			init: function() {
			},

			// Action-specific code
			create_new: function() {
				/*
				 * Check whether login is available.
				 * Simple demo of working with an API.
				 */
				var $login = $( "#id_login" ),
					m = "Username is already taken.",
					h = "<p class='alert alert-danger'>" + m + "</p>",
					$status = $( h ).hide().appendTo( $login.closest( ".form-group" ) );

				$login.on( "change", function() {

					// Login input value to check.
					var value = $login.val(),
						lang = $( "html" ).attr( "lang" ),

					// API URL.
						url = "/api/" + lang + "/login_availabilities/detail/",

					// GET values for API. Available formats: xml, json, yaml, jsonp.
						data = {
							login: value,
							format: "json"
						};

					// AJAX request to the API.
					if ( value !== "" ) {
						$.ajax( {
							dataType: "json",
							url: url,
							data: data,
							success: function( json ) {
								if ( json.status !== "available" ) {
									$status.fadeIn();
								} else {
									$status.fadeOut();
								}
							}
						} );
					}
				} ).change();
			}
		},

		main: {

			// Action-specific code
			index: function() {
				CATALOG.utils.initSwiper();

				// Rozbaleni autorek
				// pouziva BS Collapse, zde resime skryvani tlacitek
				$( ".js-author-expanded" ).on( "show.bs.collapse", function() {

					// Pro autorkach VEDLE sebe odstranime rozbalovaci tlacitka
					if ( $( ".authors-list" ).css( "display" ) === "flex" ) {
						$( ".author-cta" ).fadeOut();
					} else {
						if ( $( "#author-expanded-1" ).css( "display" ) !== "none" ) {
							$( "#author-cta-1" ).fadeOut();
						}
						if ( $( "#author-expanded-2" ).css( "display" ) !== "none" ) {
							$( "#author-cta-2" ).fadeOut();
						}
					}
				} );
				$( ".js-author-expanded" ).on( "shown.bs.collapse", function() {

					// Pri autorkach POD SEBOU skryt btn jen pod rozbalenou autorkou
					if ( $( ".authors-list" ).css( "display" ) === "block" ) {
						if ( $( "#author-expanded-1" ).css( "display" ) !== "none" ) {
							$( "#author-cta-1" ).fadeOut();
						}
						if ( $( "#author-expanded-2" ).css( "display" ) !== "none" ) {
							$( "#author-cta-2" ).fadeOut();
						}
					}
				} );

				// Pri resize, pokud jsou autorky vedle sebe, a je rozbalena jen jedna,
				// rozbalime obe dve a schovame rozbalovaci tlacitka
				// Pokud jsou rozbalene obe, schovame tlacitka
				$( window ).on( "resize", function() {
					if ( $( ".authors-list" ).css( "display" ) === "flex" ) {
						if ( $( "#author-expanded-1" ).css( "display" ) !==
						$( "#author-expanded-2" ).css( "display" ) ) {
							$( ".js-author-expanded" ).collapse( "show" );
						}
						if ( $( "#author-expanded-1" ).css( "display" ) !== "none" &&
						$( "#author-expanded-2" ).css( "display" ) !== "none" ) {
							$( ".author-cta" ).fadeOut();
						}
					}
				} );

				if ( window.google_tag_manager ) {
					modulGA.init();
				}

			}
		},

		utils: {

			initSwiper: function() {
				$( ".swiper-container" ).each( function( index, container ) {
					var swiper;
					var $container = $( container );
					var slidesPerView = $container.data( "slides_per_view" ); // 4 or 5
					if ( slidesPerView === "auto" ) {
							swiper = new Swiper( container, {
							slidesPerView: "auto",
							spaceBetween: 30,
							navigation: {
								nextEl: $container.data( "next_el" ),
								prevEl: $container.data( "prev_el" ),
								disabledClass: "swiper-button--disabled",
								hiddenClass: "swiper-button--hidden"
							}
						} );
					} else {
						swiper = new Swiper( container, {
							slidesPerView: slidesPerView,
							slidesPerGroup: slidesPerView,
							spaceBetween: -1,
							watchOverflow: true,
							roundLengths: false,
							navigation: {
								nextEl: $container.data( "next_el" ),
								prevEl: $container.data( "prev_el" ),
								disabledClass: "swiper-button--disabled",
								hiddenClass: "swiper-button--hidden"
							},
							pagination: {
								el: $container.data( "pagination_el" ),
								clickable: true
							},
							breakpoints: {
								976: {
									slidesPerView: 2,
									slidesPerGroup: 2
								},
								740: {
									slidesPerView: 1,
									slidesPerGroup: 1
								}
							}
						} );
					}
				} );
			}
		}

	};

	/*
	 * Garber-Irish DOM-based routing.
	 * See: http://goo.gl/z9dmd
	 */
	CATALOG.UTIL = {
		exec: function( controller, action ) {
			var ns = CATALOG,
				c = controller,
				a = action;

			if ( a === undefined ) {
				a = "init";
			}

			if ( c !== "" && ns[ c ] && typeof ns[ c ][ a ] === "function" ) {
				ns[ c ][ a ]();
			}
		},

		init: function() {
			var body = document.body,
			controller = body.getAttribute( "data-controller" ),
			action = body.getAttribute( "data-action" );

			CATALOG.UTIL.exec( "common" );
			CATALOG.UTIL.exec( controller );
			CATALOG.UTIL.exec( controller, action );
		}
	};

	// Expose CATALOG to the global object.
	window.CATALOG = CATALOG;

	// Initialize application.
	CATALOG.UTIL.init();
} )( window, window.jQuery );
